"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormConfigEdit = getFormConfigEdit;
exports.getFormConfigInfo = getFormConfigInfo;
exports.getFormConfigList = getFormConfigList;
exports.getFormConfigSave = getFormConfigSave;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------

function getFormConfigInfo(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/customFormTemplate/info',
    method: 'GET',
    params: data
  });
}
function getFormConfigList(pram) {
  var data = {
    keywords: pram.keywords,
    page: pram.page,
    limit: pram.limit
  };
  return (0, _request.default)({
    url: '/admin/customFormTemplate/list',
    method: 'GET',
    params: data
  });
}
function getFormConfigSave(pram) {
  var data = {
    content: pram.content,
    info: pram.info,
    name: pram.name
  };
  return (0, _request.default)({
    url: '/admin/customFormTemplate/save',
    method: 'POST',
    data: data
  });
}
function getFormConfigEdit(pram) {
  var params = {
    id: pram.id
  };
  var data = {
    content: pram.content,
    info: pram.info,
    name: pram.name
  };
  return (0, _request.default)({
    url: '/admin/customFormTemplate/update',
    method: 'POST',
    params: params,
    data: data
  });
}